import { isPanelCollapsed } from "./helpers";

export const selectPanelGroups = (state) => state.panels.groups;

export const selectPanelGroup = (groupId) => (state) =>
  state.panels.groups[groupId];

export const selectPanelSize = (groupId, panelId) => (state) =>
  state.panels.groups[groupId]?.panels[panelId]?.size;

export const selectIsPanelCollapsed = (groupId, panelId) => (state) =>
  isPanelCollapsed(state.panels.groups[groupId]?.panels[panelId]);
